import { createClient } from '@supabase/supabase-js';
import { optimizarImagen } from './imageResize';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Faltan las variables de entorno de Supabase. Verifica tu archivo .env');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Helper para subir imágenes al bucket "pictures".
// Antes de subir se redimensiona: las fotos de camara pesan varios MB y se
// muestran a un ancho de pantalla, asi que subirlas intactas solo penaliza a
// quien lee la revista.
export const uploadImage = async (file) => {
  if (!file) return null;

  const { blob, mime, ext } = await optimizarImagen(file);
  const fileName = `${Date.now()}_${Math.random().toString(36).substring(2, 9)}.${ext}`;
  const filePath = `${fileName}`;

  const { error } = await supabase.storage
    .from('pictures')
    .upload(filePath, blob, {
      contentType: mime,
      cacheControl: '3600',
      upsert: false,
    });

  if (error) {
    console.error('Error al subir imagen:', error);
    throw error;
  }

  const { data } = supabase.storage.from('pictures').getPublicUrl(filePath);
  return data.publicUrl;
};

// Red de seguridad: convierte cualquier imagen base64 que haya quedado dentro
// de un HTML (pegada desde Word, Docs, otro editor...) en un archivo del bucket
// y devuelve el HTML con URLs. Se llama justo antes de guardar, de modo que
// nunca se almacena un data URI aunque el editor no lo haya interceptado.
export const sanitizeBase64Images = async (html) => {
  if (!html || !html.includes('data:image')) return html;

  const regex = /src="(data:(image\/[a-zA-Z0-9.+-]+);base64,([^"]+))"/g;
  const matches = [...html.matchAll(regex)];
  let resultado = html;

  for (const [, dataUri, mime, base64] of matches) {
    try {
      const binario = atob(base64);
      const bytes = new Uint8Array(binario.length);
      for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);

      const optimizada = await optimizarImagen(new Blob([bytes], { type: mime }));
      const nombre = `${Date.now()}_${Math.random().toString(36).substring(2, 9)}.${optimizada.ext}`;

      const { error } = await supabase.storage
        .from('pictures')
        .upload(nombre, optimizada.blob, {
          contentType: optimizada.mime,
          cacheControl: '3600',
          upsert: false,
        });
      if (error) throw error;

      const { data } = supabase.storage.from('pictures').getPublicUrl(nombre);
      resultado = resultado.split(dataUri).join(data.publicUrl);
    } catch (e) {
      console.error('No se pudo convertir una imagen incrustada:', e);
      // Se deja el data URI tal cual: es preferible a perder la imagen.
    }
  }

  return resultado;
};

// Helper para eliminar imagen del bucket
export const deleteImageByUrl = async (url) => {
  if (!url) return;
  try {
    const marker = '/pictures/';
    const idx = url.indexOf(marker);
    if (idx === -1) return;
    const path = url.substring(idx + marker.length);
    await supabase.storage.from('pictures').remove([path]);
  } catch (e) {
    console.warn('No se pudo eliminar la imagen anterior:', e);
  }
};
